import { render, staticRenderFns } from "./centerReachRate.vue?vue&type=template&id=b2195386"
import script from "./centerReachRate.vue?vue&type=script&lang=js"
export * from "./centerReachRate.vue?vue&type=script&lang=js"
import style0 from "./centerReachRate.vue?vue&type=style&index=0&id=b2195386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports